export class CommissionAdditionalPromotor {
    public idCommissionAdditional?:number;
    public employeeId?:string;
    public employeeName?:string;
    public fechaCobro?:string;
    public capital?:number;    
    public commission?:number;
    public commissionAdjustAmount?:number;
    public finalCommission?:number;
    public comment?:string;
    public createUser?:string;
    public createDate?:Date;
    public enviado?:number;
    public fechaSimulacion?:string;
}